
export class SearchQuestionDto {
  reference: string;
  corps: number[];
  statement: string;
  comment: string;
  answer: string;
  multimediaTitle: string;
  numOfAnswers: number;
  numOfMultimedia: number;
  subject: number[];
  topic: number[];
  difficulty: number[];
  origin: number[];
  tags: number[];
  groups: number[];
  examSettings: number[];
  officialQuestion: boolean;
  /** Preguntas de IA: true solo esas, false solo las de siempre, null todas. */
  aiGenerated: boolean;
  officialNum: number;
  officialYear: number;

  constructor() {
  }
}
